var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.639,
    height: 15.154,
    viewBox: "0 0 13.639 15.154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0 1.111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 13.639,
    height: 13.639,
    transform: "translate(0 -0.353)",
    fill: "#707070",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(0 -1.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_904dc079-0720-40ec-9ae2-c53c9e1e33be",
    "data-name": "904dc079-0720-40ec-9ae2-c53c9e1e33be",
    d: "M16.214,21.617a.758.758,0,0,1-.758-.758V19.344a2.275,2.275,0,0,0-2.273-2.273H7.122a2.276,2.276,0,0,0-2.274,2.273V20.86a.758.758,0,1,1-1.515,0V19.344a3.793,3.793,0,0,1,3.789-3.788h6.062a3.793,3.793,0,0,1,3.788,3.788V20.86A.758.758,0,0,1,16.214,21.617Z",
    transform: "translate(-3.333 -6.463)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d7c63d09-fa86-4232-9ebb-52f28c53c419",
    d: "M2.678-1.111A3.789,3.789,0,1,1-1.111,2.678,3.793,3.793,0,0,1,2.678-1.111Zm0,6.062A2.273,2.273,0,1,0,.4,2.678,2.276,2.276,0,0,0,2.678,4.951Z",
    transform: "translate(4.142 1.111)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/ic_user.c1ad2a9a642ef064b3dd5a09d2573d73.svg";
export { ForwardRef as ReactComponent };